import cx from 'classnames'
import Styles from './CreditUsage.module.scss'

import { Text } from 'blaze-ui/Text/Text'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { useCreditUsage } from 'hooks/useCreditUsage'
import dayjs from 'dayjs'
import { useRootStore } from 'stores/RootStore'

export const CreditUsage = ({ className }: { className: string }) => {
  const { creditsRemaining, endDate, baseCreditsAvailable } = useCreditUsage()
  const {
    tierUsageStore: { currentSubscription },
  } = useRootStore()
  const refillDate = dayjs(endDate).add(1, 'day')
  const showCreditRefill = baseCreditsAvailable > 0 && currentSubscription?.status === 'active'
  const negativeCredits = creditsRemaining < 0

  return (
    <div className={cx(className, Styles.container)}>
      <div className={cx(Styles.creditUsageContainer, { [Styles.negativeCredits]: negativeCredits })}>
        <div className={Styles.top}>
          <Credits color={negativeCredits ? 'var(--red-50)' : 'var(--purple-50)'} />
          <Text variant="secondary">{creditsRemaining} credits</Text>
        </div>
        <div className={Styles.bottom}>
          {showCreditRefill && (
            <Text variant="metadata" color="var(--dark-40)">
              +{baseCreditsAvailable} monthly on {refillDate.format('MMM D')}
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}
